module.exports = __webpack_public_path__ + "img/01.ab8b4942.jpg";